import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-muted-foreground">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/tableau-de-bord" replace />;

  return children;
}
